import React from 'react';
export const Energium = () => {
  return <span style={{ color: 'rgb(226, 210, 42)' }}>Energium</span>;
};
